import {
  Box,
  Button,
  IconButton,
  Typography,
  useMediaQuery
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTheme } from "@emotion/react";
import useThemeColor from "../../utils/useTheme";
import {
  ArrowDropDown,
  ArrowDropUp,
  ArrowLeft,
  ArrowRight,
  Star,
  StarBorder
} from "@mui/icons-material";
import { formatDate } from "../../utils/formatDate";
import { favoriteDiaryDay } from "../../features/diary/diarySlice";
import { useDispatch } from "react-redux";

const WeekView = ({
  activeDay,
  setActiveDay,
  startDay,
  setStartDay,
  allCompletedData,
  handleDayClick,
  handleNext,
  handlePrevious,
  visibleDays,
  currentActiveData,
  setDiaryData,
  setSnackbarMessage,
  setOpenSnackbar,
  visibleDaysCount,
  days
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallerMobile = useMediaQuery(
    "(min-width: 100px) and (max-width: 390px)"
  );
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const isLaptop = useMediaQuery("(min-width: 900px) and (max-width: 1300px)");
  const styles = useThemeColor();
  const handleButtonClick = (e, handler, isDisabled) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    handler();
  };
  return (
    <Box
      display="flex"
      flexDirection={isSmallerMobile ? "column" : "row"}
      alignItems="center"
      // flexDirection={isMobile ? "column" : "row"}
      // flexDirection={"row"}
      justifyContent="center"
      // pb={isMobile ? 2 : 0}
      borderBottom={!isMobile ? `1px solid ${styles.lightGreyColor}` : "0px"}
    >
      <IconButton
        sx={{ color: styles.color, p: { md: 0, lg: 1 } }}
        aria-label="previous"
        // onClick={enhancedHandlePrevious}
        onClick={(e) => {
          const isDisabled = isMobile
            ? days?.[0]?.value === visibleDays?.[0]?.value
            : startDay === 1;
          handleButtonClick(e, handlePrevious, isDisabled);
        }}
        disabled={
          isMobile
            ? days?.[0]?.value === visibleDays?.[0]?.value
            : startDay === 1
        }
      >
        {isSmallerMobile ? (
          <ArrowDropUp sx={{ height: "26px", width: "26px" }} />
        ) : isMobile ? (
          <ArrowLeft sx={{ height: "26px", width: "26px" }} />
        ) : (
          <ArrowBackIosIcon />
        )}
      </IconButton>
      <Box
        display={"flex"}
        sx={{
          backgroundColor: styles.background,
          padding: { md: "0 0px 10px 0", lg: "0 10px 20px 10px" },
          gap: isLaptop ? "25px" : { md: "2px", lg: "30px" },
          ...(isMobile && { gap: "8px" })
        }}
      >
        {visibleDays?.map(({ title, value, day }) => {
          return (
            <Box
              display="flex"
              onClick={() => handleDayClick(value)} // Only handle click if day is enabled
              alignItems="center"
              justifyContent={"center"}
              flexDirection="column"
              gap={isMobile ? 0.4 : 1}
              borderRadius={3}
              // height={80}
              sx={{
                ...(isMobile && { minWidth: "180px" }),
                cursor: "pointer",
                padding: { lg: "8px", md: "8px 3px" },
                ...((isMobile || isTablet) && { padding: "5px" }),
                color: activeDay === value ? "white" : "#9e9e9e",
                backgroundColor:
                  activeDay === value
                    ? styles.modBackgroundBlocks
                    : "transparent"
              }}
              key={value}
            >
              {isMobile ? (
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: "16px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "8px",
                    fontWeight: 600,
                    border: allCompletedData?.includes(value)
                      ? "2px solid #368AD0"
                      : "1px solid rgba(0,0,0,0.08)",
                    color:
                      formatDate(value, false) === "Today"
                        ? "#03B55C"
                        : styles.primaryColor
                  }}
                >
                  {/* Left: Date + Day */}
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 700,
                      whiteSpace: "nowrap"
                    }}
                  >
                    {formatDate(value, false)}
                    <Box
                      component="span"
                      sx={{
                        ml: 0.75,
                        fontSize: "12px",
                        fontWeight: 500,
                        color: styles.lightBlack
                      }}
                    >
                      • {day}
                    </Box>
                  </Typography>

                  {/* Right: Favorite */}
                  <IconButton
                    size="small"
                    sx={{
                      p: 0.5,
                      borderRadius: "10px",
                      backgroundColor: currentActiveData?.isFavorite
                        ? "rgba(255, 193, 7, 0.12)"
                        : "transparent",
                      "&:hover": {
                        backgroundColor: currentActiveData?.isFavorite
                          ? "rgba(255, 193, 7, 0.2)"
                          : "rgba(0,0,0,0.06)"
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();

                      if (
                        !(
                          currentActiveData?.entry800g?.length ||
                          currentActiveData?.protein?.length ||
                          currentActiveData?.otherFood?.length
                        )
                      ) {
                        setSnackbarMessage(
                          "You can't favorite an empty diary day."
                        );
                        setOpenSnackbar(true);
                        return;
                      }

                      dispatch(
                        favoriteDiaryDay({
                          diaryId: currentActiveData?._id,
                          isFavorite: !currentActiveData?.isFavorite
                        })
                      );

                      setDiaryData((prev) =>
                        prev.map((item) =>
                          item._id === currentActiveData?._id
                            ? { ...item, isFavorite: !item.isFavorite }
                            : item
                        )
                      );
                    }}
                  >
                    {currentActiveData?.isFavorite ? (
                      <Star sx={{ fontSize: "18px", color: styles.yellow }} />
                    ) : (
                      <StarBorder
                        sx={{ fontSize: "18px", color: styles.color }}
                      />
                    )}
                  </IconButton>
                </Box>
              ) : (
                <>
                  <Typography
                    p={"3px 5px"}
                    borderRadius={"20px"}
                    sx={{ background: "#a7c8e6", color: "black" }}
                    color={styles.color}
                    fontSize="10px"
                    mb={1}
                  >
                    {day}
                  </Typography>
                  <Typography
                    color={styles.color}
                    fontSize="14px"
                    fontWeight={700}
                  >
                    {title?.split(" ")?.[0]}
                  </Typography>
                  <Button
                    sx={{
                      ":disabled": {
                        color: `${styles.lightBlack} !important`
                      },
                      ...(allCompletedData?.includes(value) && {
                        border: "2px solid #368AD0"
                      }),
                      color:
                        activeDay === value ? "#FCFCFC" : styles.disabledColor,
                      backgroundColor:
                        activeDay === value ? "#368AD0" : "transparent",
                      minWidth: "40px",
                      borderRadius: "50%",
                      padding: "6px"
                    }}
                  >
                    {title?.split(" ")?.[1]}
                  </Button>
                </>
              )}
            </Box>
          );
        })}
      </Box>
      <IconButton
        sx={{ color: styles.color, p: { md: 0, lg: 1 } }}
        aria-label="next"
        // onClick={enhancedHandleNext}
        onClick={(e) => {
          const isDisabled = isMobile
            ? days?.at(-1)?.value === visibleDays?.at(-1)?.value
            : startDay + (visibleDays?.length || 0) > days?.length;
          handleButtonClick(e, handleNext, isDisabled);
        }}
        disabled={
          isMobile
            ? days?.at(-1)?.value === visibleDays?.at(-1)?.value
            : startDay + (visibleDays?.length || 0) > days?.length
        }
      >
        {isSmallerMobile ? (
          <ArrowDropDown sx={{ height: "26px", width: "26px" }} />
        ) : isMobile ? (
          <ArrowRight sx={{ height: "26px", width: "26px" }} />
        ) : (
          <ArrowForwardIosIcon />
        )}
      </IconButton>
    </Box>
  );
};

export default WeekView;
